import { Actions } from '../AppReducer'

export default async function logout() {
    global.clearModals()

    // Stop audio playback
    global.uiDispatch(Actions.stopAudio())

    // Clear tokens first
    localStorage.removeItem('at')
    localStorage.removeItem('rt')
    localStorage.removeItem('lastSearch')

    // Dispatch logout BEFORE clearing store to prevent queries from refetching
    global.uiDispatch(Actions.logOut())

    // Wait a tick to ensure React updates propagate
    await new Promise(resolve => setTimeout(resolve, 0))

    try {
        // Use clearStore() instead of resetStore() to avoid refetching active queries
        await global.apolloClient.clearStore()
    } catch (error) {
        console.error(`error clearing Apollo client store: ${error}`)
    }
}
